/**
 * Shared confirm attrs for <anear-nav> / <anear-action>:
 * - prompt / prompt="true" => default confirm copy
 * - prompt="Custom…" => custom copy
 * - stay (or reset alias) / exit => button labels
 */
export const parseConfirmPromptAttrs = (el) => {
  if (!el) return { prompt: null, stayLabel: null, exitLabel: null }

  const hasTruthyAttr = (attr) =>
    el.hasAttribute(attr) || el.getAttribute(attr) === 'true'

  const promptAttr = (el.getAttribute('prompt') || '').trim()
  let prompt = null
  if (hasTruthyAttr('prompt') || el.getAttribute('prompt') === 'true') {
    const lowerPromptAttr = promptAttr.toLowerCase()
    if (!promptAttr || lowerPromptAttr === 'true' || lowerPromptAttr === 'false') {
      prompt = true
    } else {
      prompt = promptAttr
    }
  }

  const stayAttr = (el.getAttribute('stay') || '').trim()
  const resetAttr = (el.getAttribute('reset') || '').trim()
  const stayLabel = stayAttr || resetAttr || null
  const exitAttr = (el.getAttribute('exit') || '').trim()
  const exitLabel = exitAttr || null

  return { prompt, stayLabel, exitLabel }
}
